module.exports = __webpack_public_path__ + "img/59_8.dfe19fa8.png";